import React from 'react';

function Dummy(){

  
    
    let text = "Knee Replacment Surgeon";
    let position = text.search("Surgeon");
    let stringlength = text.length
    let substr = text.substring(0, position-1);

    alert(substr); // 👉️ "Techie"

  
    return (
      <div>
        <p>{substr}</p>
      </div>
    );
  };



export default Dummy;